import React from 'react';
import { CARD } from '../ui';
import { TRACK, DATA_HUE } from './theme';

// Direction is spelled out with an arrow and a sign as well as a color, so the
// delta never depends on hue alone.
const Delta = ({ change, comparisonLabel }) => {
  if (change === null || change === undefined) {
    return comparisonLabel ? <span className="text-sm text-gray-500">{comparisonLabel}</span> : null;
  }
  const up = change > 0;
  const flat = change === 0;
  const tone = flat ? 'text-gray-400' : up ? 'text-emerald-400' : 'text-amber-400';
  return (
    <span className={`text-sm font-medium ${tone}`}>
      {flat ? '±' : up ? '▲' : '▼'} {up ? '+' : ''}{change}%
      {comparisonLabel && <span className="text-gray-500 font-normal"> {comparisonLabel}</span>}
    </span>
  );
};

// A ratio against its total, drawn on a lighter step of the same track so the
// unfilled remainder still reads as part of the bar.
const Meter = ({ value, total }) => {
  const pct = total > 0 ? Math.min(100, Math.round((value / total) * 100)) : 0;
  return (
    <div className="mt-3">
      <div className="h-1.5 w-full rounded-full overflow-hidden" style={{ backgroundColor: TRACK }}>
        <div className="h-full rounded-full" style={{ width: `${pct}%`, backgroundColor: DATA_HUE }} />
      </div>
    </div>
  );
};

const StatTile = ({ label, value, hero, change, comparisonLabel, caption, meter }) => (
  <div className={`${CARD} p-6`}>
    <p className="text-sm font-medium text-gray-400">{label}</p>
    {/* Proportional figures: tabular-nums makes a large standalone number look loose. */}
    <p className={`mt-2 font-semibold text-white leading-none ${hero ? 'text-5xl' : 'text-3xl'}`}>
      {value}
    </p>
    <div className="mt-3 min-h-[1.25rem]">
      <Delta change={change} comparisonLabel={comparisonLabel} />
    </div>
    {meter && <Meter value={meter.value} total={meter.total} />}
    {caption && <p className="mt-2 text-sm text-gray-500">{caption}</p>}
  </div>
);

export default StatTile;
